import axios from "axios";

export default {
    /**
     * 
     * @param {Object} obj 
     * @param {String} obj.title 
     * @param {String} obj.couponId 
     */
    search(obj) {
        return axios.post("/course/Study/search", obj);
    }
}